import { Injectable } from '@angular/core';
import { MusiquesMix } from '../../ressources/types/musiquesMix';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataPassService {

  public import_files: any;
  public import_configTable: any;
  public import_winmediaData: any;
  public import_proprietes: any;
  public import_categories: any;
  public import_genres_association: any;
  public import_station_with_genres_association: any;
  public import_countriesJSON: any;
  public import_countries: any;

  public musiques_mix: MusiquesMix[] = [];

  public selectedWaveformSource = new BehaviorSubject(9999);
  selectedWaveform = this.selectedWaveformSource.asObservable();

  public searchMusics_result = [];

  public statusWaveformSource = new BehaviorSubject([]);
  statusWaveform = this.statusWaveformSource.asObservable();

  constructor() { }
}
